/*
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

const BASE = "/activities";

export const ACTIVITIES_ROUTES = {
  BASE,
  ROOT: `${BASE}/*`,
  NAME: "Activities",
} as const;

export const ACTIVITY_DETAIL_ROUTE = `${BASE}/:id`;

export const DURATION_OPTIONS = [
  { value: 1, label: "1 minute" },
  { value: 15, label: "15 minutes" },
  { value: 30, label: "30 minutes" },
  { value: 45, label: "45 minutes" },
  { value: 60, label: "1 hour" },
  { value: 90, label: "1.5 hours" },
  { value: 120, label: "2 hours" },
  { value: 150, label: "2.5 hours" },
  { value: 180, label: "3 hours" },
  { value: 210, label: "3.5 hours" },
  { value: 240, label: "4 hours" },
  { value: 270, label: "4.5 hours" },
  { value: 300, label: "5 hours" },
  { value: 330, label: "5.5 hours" },
  { value: 360, label: "6 hours" },
  { value: 390, label: "6.5 hours" },
  { value: 420, label: "7 hours" },
  { value: 450, label: "7.5 hours" },
  { value: 480, label: "8 hours" },
  { value: 1440, label: "1 day" },
  { value: 2880, label: "2 days" },
  { value: 4320, label: "3 days" },
];

export const DURATION_OPTIONS_SHORT = [
  { value: 1, label: "1 min" },
  { value: 15, label: "15 min" },
  { value: 30, label: "30 min" },
  { value: 45, label: "45 min" },
  { value: 60, label: "1 hr" },
  { value: 90, label: "1.5 hrs" },
  { value: 120, label: "2 hrs" },
  { value: 150, label: "2.5 hrs" },
  { value: 180, label: "3 hrs" },
  { value: 210, label: "3.5 hrs" },
  { value: 240, label: "4 hrs" },
  { value: 270, label: "4.5 hrs" },
  { value: 300, label: "5 hrs" },
  { value: 330, label: "5.5 hrs" },
  { value: 360, label: "6 hrs" },
  { value: 390, label: "6.5 hrs" },
  { value: 420, label: "7 hrs" },
  { value: 450, label: "7.5 hrs" },
  { value: 480, label: "8 hrs" },
  { value: 1440, label: "1 day" },
  { value: 2880, label: "2 days" },
  { value: 4320, label: "3 days" },
];

export const DEFAULT_ACTIVITY_DURATION = 30;
